import { DataTableHeader } from 'Lib/TypeDefs';

export const HDR_SIMPLE_TABLE = [
  new DataTableHeader({ value: 'id', text: 'ID', width: '1%' }),
  new DataTableHeader({ value: 'name', text: 'Name' }),
];
